import { Outlet } from 'react-router-dom';

// styles
import {
  HomePageContainer,
} from './HomePage.styles.js';


export default function HomePage() {

  return (
    <HomePageContainer>
      <Outlet />
    </HomePageContainer>
  );
}